// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DownloadButton_wrapper__CHnBh"};